/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Uuid } from "../uuid_util/uuid";
import { Category_Enum, category_EnumFromJSON, category_EnumToJSON } from "./category";
import { StructureObject } from "./structure_object";

export const protobufPackage = "structure";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface Structure {
  utime: number;
  uuid: Uuid | undefined;
  name: string;
  siteId: Uuid | undefined;
  category: Category_Enum;
  description: string;
  object: StructureObject | undefined;
  metadata: string;
}

function createBaseStructure(): Structure {
  return {
    utime: 0,
    uuid: undefined,
    name: "",
    siteId: undefined,
    category: 0,
    description: "",
    object: undefined,
    metadata: "",
  };
}

export const Structure = {
  encode(message: Structure, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.uuid !== undefined) {
      Uuid.encode(message.uuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.siteId !== undefined) {
      Uuid.encode(message.siteId, writer.uint32(34).fork()).ldelim();
    }
    if (message.category !== 0) {
      writer.uint32(40).int32(message.category);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.object !== undefined) {
      StructureObject.encode(message.object, writer.uint32(58).fork()).ldelim();
    }
    if (message.metadata !== "") {
      writer.uint32(66).string(message.metadata);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Structure {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructure();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.uuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.siteId = Uuid.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.object = StructureObject.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.metadata = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Structure {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      uuid: isSet(object.uuid) ? Uuid.fromJSON(object.uuid) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      siteId: isSet(object.siteId) ? Uuid.fromJSON(object.siteId) : undefined,
      category: isSet(object.category) ? category_EnumFromJSON(object.category) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      object: isSet(object.object) ? StructureObject.fromJSON(object.object) : undefined,
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : "",
    };
  },

  toJSON(message: Structure): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.uuid !== undefined) {
      obj.uuid = Uuid.toJSON(message.uuid);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.siteId !== undefined) {
      obj.siteId = Uuid.toJSON(message.siteId);
    }
    if (message.category !== 0) {
      obj.category = category_EnumToJSON(message.category);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.object !== undefined) {
      obj.object = StructureObject.toJSON(message.object);
    }
    if (message.metadata !== "") {
      obj.metadata = message.metadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Structure>, I>>(base?: I): Structure {
    return Structure.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Structure>, I>>(object: I): Structure {
    const message = createBaseStructure();
    message.utime = object.utime ?? 0;
    message.uuid = (object.uuid !== undefined && object.uuid !== null) ? Uuid.fromPartial(object.uuid) : undefined;
    message.name = object.name ?? "";
    message.siteId = (object.siteId !== undefined && object.siteId !== null)
      ? Uuid.fromPartial(object.siteId)
      : undefined;
    message.category = object.category ?? 0;
    message.description = object.description ?? "";
    message.object = (object.object !== undefined && object.object !== null)
      ? StructureObject.fromPartial(object.object)
      : undefined;
    message.metadata = object.metadata ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
